module.exports = __webpack_public_path__ + "img/top-start-button-mobile.29fc8b99.png";